export const labelColourMap = {
  red: "bg-red-100",
  yellow: "bg-yellow-100",
  orange: "bg-orange-100",
};
